import { useQuery } from '@tanstack/react-query';
import { backendServices } from '../services';

type Params = Parameters<InstanceType<typeof backendServices.Apis.DocumentApi>['getSkeleton']>[0];

export function useDocumentSkeleton({
    businessDocType,
    buyerCompanyId,
    customerId,
    supplierCompanyId,
    client,
    documentClass,
    enabled = true,
}: Params & { enabled?: boolean }) {
    const query = useQuery({
        queryKey: [
            'documentSkeleton',
            businessDocType,
            buyerCompanyId,
            customerId,
            supplierCompanyId,
            client,
            documentClass,
        ],
        queryFn: async () => {
            const api = new backendServices.Apis.DocumentApi();
            const { data } = await api.getSkeleton({
                businessDocType,
                buyerCompanyId,
                customerId,
                supplierCompanyId,
                client,
                documentClass,
            });

            return data;
        },
        staleTime: Infinity,
        cacheTime: Infinity,
        enabled: enabled,
    });

    return query;
}
